<template>
    <div class="page">
        <div class="user">
            <div class="member_temp1">
                <div class="top" @click="toBindPhone">
                    <div class="img-box">
                        <img src="@/assets/mifi/52.png" alt="">
                    </div>
                    <div class="body">{{ loginText }}</div>
                    <!-- <div class="btn-group">
                    <van-icon name="qr" />
                    <van-icon name="setting-o" />
                </div> -->
                </div>
                <div class="btns">
                    <div class="btn">
                        <div class="num">0</div>
                        <div class="content">积分</div>
                    </div>
                    <div class="btn">
                        <div class="num">0</div>
                        <div class="content">活跃度</div>
                    </div>
                    <div class="btn">
                        <div class="num">0</div>
                        <div class="content">优惠券</div>
                    </div>
                </div>
            </div>
            <div class="decorate-components">
                <div class="top1" @click="toSelectOrder">
                    <div class="title-wrap">我的订单</div>
                    <div class="more">
                        查询<van-icon name="arrow" />
                    </div>
                </div>
                <!-- <div class="group">
                    <div class="icon-item">
                        <img src="@/assets/mifi/payment.png" alt="">
                        <div class="l-title">待付款</div>
                    </div>
                    <div class="icon-item">
                        <img src="@/assets/mifi/send.png" alt="">
                        <div class="l-title">待发货</div>
                    </div>
                    <div class="icon-item">
                        <img src="@/assets/mifi/receive.png" alt="">
                        <div class="l-title">待收货</div>
                    </div>
                    <div class="icon-item">
                        <img src="@/assets/mifi/refund.png" alt="">
                        <div class="l-title">退换货</div>
                    </div>
                    <div class="icon-item">
                        <img src="@/assets/mifi/message.png" alt="">
                        <div class="l-title">评价</div>
                    </div>
                </div> -->
            </div>

            <div class="decorate-components">
                <div class="top1" style="border: none;padding: 0;" @click="toKefu()">
                    <van-icon name="cluster-o" />
                    <div class="title-wrap" style="font-weight: normal;font-size: 16px;">联系客服</div>
                    <div class="more">
                        <van-icon name="arrow" />
                    </div>
                </div>
            </div>

            <div class="decorate-components">
                <div class="top1" style="border: none;padding: 0;" @click="showJie()">
                    <van-icon name="cluster-o" />
                    <div class="title-wrap" style="font-weight: normal;font-size: 16px;">公司简介</div>
                    <div class="more">
                        <van-icon name="arrow" />
                    </div>
                </div>
            </div>

            <div class="decorate-components">
                <div class="top1" style="border: none;padding: 0;" @click="toOut()">
                    <van-icon name="cluster-o" />
                    <div class="title-wrap" style="font-weight: normal;font-size: 16px;">注销登录</div>
                    <div class="more">
                        <van-icon name="arrow" />
                    </div>
                </div>
            </div>

            <div class="decorate-components">
                <div class="top1" style="border: none;padding: 0;" @click="toBindPhone()">
                    <van-icon name="chat-o" />
                    <div class="title-wrap" style="font-weight: normal;font-size: 16px;">绑定手机号获取更多信息</div>
                    <div class="more">
                        <van-button type="primary" size="mini" round color="#7232dd">立即绑定</van-button>
                    </div>
                </div>
            </div>
            <div class="f-tab">
                <van-tabbar v-model="active" @change="onChange">
                    <van-tabbar-item icon="home-o">首页</van-tabbar-item>
                    <van-tabbar-item icon="friends-o">我的</van-tabbar-item>
                </van-tabbar>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast, Dialog } from 'vant';
import { wxRequest } from '@/api/user'
export default {
    data() {
        return {
            loginText: '登录/注册',
            active: 1
        }
    },
    created() {
        var loginPhone = localStorage.getItem('myLoginPhone');
        if (loginPhone && loginPhone.length > 5) {
            this.loginText = '欢迎回来 ' + loginPhone.slice(0, 3) + '*****' + loginPhone.slice(8);
        }
    },
    methods: {
        toSelectOrder() {
            var loginPhone = localStorage.getItem('myLoginPhone');
            if (loginPhone && loginPhone.length > 5) {
                this.$router.push({ path: '/liu/selectOrder' });
            } else {
                Dialog.confirm({
                    title: "绑定提示",
                    message: "请先绑定手机号后，再来进行查询操作",
                }).then(() => {
                }).catch(() => { });
                return;
            }
        },
        toKefu() {
            Dialog.confirm({
                title: "联系客服",
                message: "请添加客服QQ号：1587372322 ",
            }).then(() => {
            }).catch(() => { });
        },
        toOut() {
            var loginPhone = localStorage.getItem('myLoginPhone');
            if (loginPhone && loginPhone.length > 5) {
                Dialog.confirm({
                    title: "温馨提示",
                    message: "确定要进行注销手机号操作吗？ ",
                }).then(() => {
                    localStorage.removeItem('myLoginPhone')
                    Toast.fail('注销成功！');
                    this.loginText = "登录/注册";
                }).catch(() => { });
            } else {
                Toast.fail('未查询到注册信息！');
            }



        },
        toBindPhone() {
            var loginPhone = localStorage.getItem('myLoginPhone');
            if (loginPhone && loginPhone.length > 5) {
                Toast.fail('已绑定手机号');
                return;
            } else {
                this.$router.push({ path: '/liu/bindPhone' });
            }
        },
        onChange(data) {
            if (data === 0) {
                this.$router.push({ path: '/liu/buyShebei' });
            }
        },

        showJie() {
            Dialog.confirm({
                title: '公司简介',
                width: '90%',
                showCancelButton: false,
                messageAlign: 'left',
                confirmButtonColor: '#ee0a24',
                message: `
                武汉卿和网络科技有限公司（以下简称：卿和网络）成立于2024-04-08，企业位于河南省郑州市二七区连云路橄榄城都市广场B座1409室。
公司营业范围如下：电子产品和日用产品修理业，经营范围包含：一般项目：通讯设备销售；电子产品销售；计算机软硬件及辅助设备批发；计算机及办公设备维修；办公设备销售；
移动通信设备销售；电子元器件批发；技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；物联网技术研发；网络技术服务；物联网应用服务；
物联网技术服务（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）许可项目：第一类增值电信业务；
第二类增值电信业务（依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准）。
        
`,
            }).then(() => {
                // on confirm
            }).catch(() => {
                // on cancel
            });
        },


    }
}
</script>
<style scoped lang="less">
.page {
    min-height: 100%;
    flex-direction: column;
    width: 100%;
    display: flex;
    background: #f5f5f5;

    .user {
        padding-top: 27px;
        background: #f5f5f5 url('~@/assets/mifi/member-bg-4.png')no-repeat left top;
        background-size: 100%;

        .top {
            padding: 18px 13px 27px;
            flex-wrap: nowrap;
            display: flex;
            align-items: center;

            .img-box {
                width: 57px;
                height: 57px;
                flex-shrink: 0;
                overflow: hidden;
                box-sizing: border-box;
                border: 0.5px solid #e6e7eb;
                margin-right: 11px;
                border-radius: 50%;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .body {
            font-size: 16px;
            flex: 1;
        }

        .van-icon {
            font-size: 22px;
            margin-right: 12px;
        }

        .btns {
            box-sizing: border-box;
            height: 66px;
            padding: 9px 0 9px;
            display: flex;
            align-items: center;
            font-family: PingFang SC;
            font-style: normal;

            .btn {
                flex: 1;
                text-align: center;

                .num {
                    font-weight: 700;
                    font-size: 20px;
                    height: 28px;
                    line-height: 28px;
                    color: #212121;
                }

                .content {
                    font-size: 13px;
                    height: 19px;
                    line-height: 19px;
                    margin: 0 auto 0;
                    color: #565656;
                }
            }
        }
    }

    .decorate-components {
        width: 86%;
        border-radius: 14px;
        background: #fff;
        margin: auto;
        padding: 14px 13px;
        margin-bottom: 14px;

        .top1 {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #dedede;
            padding-bottom: 15px;

            .title-wrap {
                line-height: 18px;
                font-size: 18px;
                text-align: left;
                font-weight: bold;
                flex: 1;
            }

            .more {
                font-size: 13px;
                color: #969696;

                .van-icon-arrow {
                    font-size: 18px;
                    color: #969696;
                    font-weight: normal;
                }
            }
        }

        .group {
            display: flex;
            align-items: center;
            box-sizing: border-box;
            height: 86px;

            .icon-item {
                text-align: center;
                flex: 1;
                color: #565656;
                font-size: 13px;

                img {
                    width: 32px;
                    height: 32px;
                    margin-bottom: 9px;
                }

                .van-icon {
                    font-size: 32px;
                    margin-bottom: 9px;
                    color: #565656;
                    margin-right: 0;
                }
            }
        }
    }
}
</style>